import styles from "../../screens/Requirement/Requirement.module.css";
import { Box, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { formatDate, formatTime } from "../../utils/const";

const RecruiterApplyJobList = ({
  name,
  mode,
  client,
  salary,
  skills,
  requirement,
  date,
  jobDetailsListRow,
  handleShowJobDetails,
}) => {
  const [showMore, setShowMore] = useState(false);

  const contentRef = useRef(null);

  const handleonClickViewDetails = () => {
    jobDetailsListRow(requirement);
    handleShowJobDetails();
  };

  return (
    <Box className={styles.matches_resume_result}>
      <Box sx={{ backgroundColor: "#fff !important",width:"100%" }}>
        <span style={{width:"87%"}}>
          <Typography sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={handleonClickViewDetails}
          >
            <b>{name}</b>
          </Typography>
          <Typography>
            {mode}
          </Typography>
          <Typography>
            {client}
          </Typography>
          <Typography>
            {/* {requirement?.requirement_type?.includes("full_Time")
              ? "Salary"
              : "Rate"}{" "}
            :{" "} */}

            ${salary}
            {salary > 0
              ? requirement?.requirement_type?.includes("full_Time")
                ? "K Yearly"
                : " Hourly"
              : "Non Disclosed"}{" "}

          </Typography>

          <Typography>
            Mandatory skills:{" "}
            <b
              style={{
                overflow: "hidden",
                transition: "height 0.1s ease",
                height: showMore
                  ? `${contentRef.current?.scrollHeight}px`
                  : `${contentRef.current?.firstChild?.offsetHeight}px`,
              }}
            >
              <b ref={contentRef}>
                {showMore
                  ? skills // Show full text
                  : `${skills?.slice(0, 20)}`}{" "}
                <a
                  onClick={() => setShowMore(!showMore)}
                  style={{
                    textDecoration: "underline",
                    color: "#4b8ae9",
                    paddingLeft: "15px",
                    fontSize: "13px",
                    cursor: "pointer",
                  }}
                >
                  {skills?.length > 20 &&
                    (showMore ? "View Less" : "View More")}
                </a>
              </b>
            </b>
          </Typography>
        </span>

        <span style={{ alignSelf: "flex-end",width:"30%" }}>
          <span
            style={{
              display: "flex",
              alignItems: "end",
              padding: "10px 10px 0 40px",
            }}
          >
            <Typography>{`${formatDate(date)}, ${formatTime(
              date
            )}`}</Typography>
          </span>
          <div
            style={{
              marginTop: "35px",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <button
              style={{ marginLeft: "10px" }}
              onClick={handleonClickViewDetails}
            >
              View & Apply
            </button>
          </div>
        </span>
      </Box>
    </Box>
  );
};

export default RecruiterApplyJobList;
